<template>
  <div>
    <header-portrate />
    <exports-print ref="exportbar" />

    <div>
      <bread-crumbs :items="items" />
      <tabs-comp :tabs="tabs" />

      <v-row class="mt-2 mb-2" style="margin-inline-start:2px;margin-inline-end:35px;">
        <v-col cols="12">
          <technical-inspection-reports-module />
        </v-col>
      </v-row>
    </div>

    <Footer />
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import HeaderPortrate from '@/components/Header-Portrate.vue';
import ExportsPrint from '@/components/exports-print.vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import Footer from '@/components/Footer.vue';
import TechnicalInspectionReportsModule from '@/n-compnents/TechnicalInspectionReportsModule.vue';
import { getVisibleTabsForRoute } from '@/menu/menuService';

export default {
  name: 'TechnicalInspectionReportsView',
  components: {
    HeaderPortrate,
    ExportsPrint,
    breadCrumbs,
    TabsComp,
    Footer,
    TechnicalInspectionReportsModule
  },
  data() {
    return {
      items: [
        { text: 'التقارير', disabled: false, href: '' },
        { text: 'تقارير الفحص الفني', disabled: true, href: '' }
      ]
    };
  },
  computed: {
    lang() {
      if (this.$cookies.get(this.$store.state.LangCooki) != null) {
        if (this.$cookies.get(this.$store.state.LangCooki) == 'en') {
          return this.$store.state.lang.en;
        } else if (this.$cookies.get(this.$store.state.LangCooki) == 'ur') {
          return this.$store.state.lang.ur;
        } else {
          return this.$store.state.lang.ar;
        }
      }
      else if (this.$store.state.deflang == 'en') {
        return this.$store.state.lang.en;
      }
      else if (this.$store.state.deflang == 'ur') {
        return this.$store.state.lang.ur;
      }
      return this.$store.state.lang.ar;
    },
    tabs() {
      return getVisibleTabsForRoute(this.$store.getters['state'], this.lang, this.$route.path);
    }
  }
};
</script>
